import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { Reveal, SectionHeading, HeroBanner } from "@/components/Section";
import { useContent } from "@/context/ContentContext";

export default function Brands() {
  const { content } = useContent();
  const BRANDS = content.brands || [];
  return (
    <div data-testid="brands-page">
      <section className="relative overflow-hidden border-b border-border carbon-texture">
        <HeroBanner src={content.page_banners?.brands} />
        <div className="relative mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8">
          <span className="text-xs font-bold uppercase tracking-[0.3em] text-secondary">
            {content.page_headers?.brands_eyebrow || "What We Work With"}
          </span>
          <h1 className="mt-4 font-heading text-5xl font-bold tracking-tight text-white md:text-6xl">
            {content.page_headers?.brands_title || "Partner Brands"}
          </h1>
          <p className="mt-4 max-w-2xl text-lg text-white/70">
            {content.page_headers?.brands_description || "We proudly represent world-class automotive brands, delivering genuine, high-performance products to riders and workshops across Bangladesh."}
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl space-y-px bg-border px-0 py-0">
        {BRANDS.map((b, i) => (
          <Reveal key={b.name}>
            <div
              data-testid={`brand-block-${b.name.replace(/\s/g, "-").toLowerCase()}`}
              className={`grid items-center gap-8 bg-background p-8 md:grid-cols-2 md:p-14 ${
                i % 2 ? "md:[&>*:first-child]:order-2" : ""
              }`}
            >
              <div>
                <div className="flex h-28 w-fit items-center rounded-xl bg-white px-10 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg group">
                  <img src={b.logo} alt={b.name} className="h-16 w-auto object-contain transition-transform duration-300 group-hover:scale-110 md:h-20" />
                </div>
                <span className="mt-4 block text-sm font-bold uppercase tracking-[0.2em] text-primary">
                  {b.tag}
                </span>
                <p className="mt-5 max-w-md text-base leading-relaxed text-muted-foreground">
                  {b.desc}
                </p>
              </div>
              <ul className="space-y-4">
                {(b.details || []).map((d) => (
                  <li key={d} className="flex items-center gap-3 border-l-2 border-primary bg-card p-4">
                    <CheckCircle2 className="h-5 w-5 shrink-0 text-primary" />
                    <span className="text-sm font-medium text-foreground">{d}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </section>

      <section className="border-t border-border bg-card py-16 text-center">
        <SectionHeading
          title="Interested In Our Product Lines?"
          align="center"
          description="Explore the full catalog or reach out to our team for inquiries."
        />
        <div className="flex justify-center gap-4">
          <Link
            to="/products"
            data-testid="brands-explore-products"
            className="flex items-center gap-2 bg-primary px-7 py-3 font-heading text-sm font-bold tracking-wide text-white transition-colors hover:bg-primary/90 shadow-md hover:shadow-lg"
          >
            View Products <ArrowRight className="h-4 w-4" />
          </Link>
          <Link
            to="/support"
            className="border-2 border-primary px-7 py-3 font-heading text-sm font-bold tracking-wide text-primary transition-colors hover:bg-primary hover:text-white"
          >
            Contact Us
          </Link>
        </div>
      </section>
    </div>
  );
}
